import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

// server.ts looks for this tag in the rendered HTML and answers with a real 404,
// so Google drops the URL instead of indexing a copy of another page (a soft 404).
export const NOT_FOUND_STATUS_META = 'x-render-status';

@Injectable({ providedIn: 'root' })
export class NotFoundService {
  constructor(private meta: Meta, private title: Title) {}

  markNotFound(): void {
    this.title.setTitle('Page not found | Atmavaan');
    this.meta.updateTag({ name: 'robots', content: 'noindex, follow' });
    this.meta.updateTag({ name: NOT_FOUND_STATUS_META, content: '404' });
    this.meta.removeTag("name='description'");
  }

  clear(): void {
    this.meta.removeTag(`name='${NOT_FOUND_STATUS_META}'`);
    this.meta.updateTag({ name: 'robots', content: 'index,follow' });
  }
}
